import COPY from '~pricing/lib/PackageFeatures/details/categoryCopy';
import EXPERIMENT_CATEGORY_COPY from '~pricing/experiments/grow_2792_pnp_refresh_v1/copy/experimentCategoryCopy';

export default [
  {
    category: EXPERIMENT_CATEGORY_COPY.grow_2792_form_survey_capabilities,
    features: [
      'grow_2792_survey_create_limit',
      'grow_2792_questions_per_form_survey',
      'base_response_count',
      'web_social_email_responses',
      'collector_create_limit',
      'pop_up_collector',
      'mobile_apps_ios_android',
      'payment_qt',
      'track_email_responses',
      'grow_2792_recurring_surveys',
      'kiosk_mode_inactivity_timer',
      'kiosk_mode_passcode_lock',
    ],
  },
  {
    category: EXPERIMENT_CATEGORY_COPY.grow_2792_team_collaboration,
    features: [
      'add_users',
      'collaboration',
      'build_surveys_together',
      'analyze_results_together',
      'custom_templates',
      'team_themes',
      'shared_library',
    ],
  },
  {
    category: COPY.FAST_SUPPORT,
    features: ['email_support', 'priority_email_support', 'phone_support', 'grow_2792_customer_success_manager'],
  },
  {
    category: EXPERIMENT_CATEGORY_COPY.grow_2792_team_management,
    features: ['team_ownership', 'user_management', 'grow_2792_advanced_collaboration', 'consolidated_billing'],
  },
  {
    category: EXPERIMENT_CATEGORY_COPY.grow_2792_survey_builder,
    features: [
      'essential_question_types',
      'all_languages_supported',
      'pagination',
      'labeling_titles_numbering',
      'create_templates_enabled',
      'question_library',
      '508_accessibility',
      'collect_contact_information',
      'video_question_type',
      'quiz_scoring_and_instant_results',
      'create_skip_logic_enabled',
      'file_upload',
      'matrix_question_type',
      'best_worst_qt',
      'ranking_question_type',
      'slider_question_type',
      'rating_question_type',
      'quizzes_pro',
      'menu_matrix_enabled',
      'multilingual',
      'create_randomization_enabled',
      'a_b_testing',
      'create_quotas_enabled',
      'click_map_qt',
      'advanced_logic',
      'multiple_block_rotation_enabled',
      'custom_question_bank',
    ],
  },
  {
    category: COPY.CUSTOMIZATION_BRANDING,
    features: [
      'progress_bar',
      'text_formatting',
      'create_custom_theme_enabled',
      'create_logo_enabled',
      'premium_themes',
      'collector_friendly_url_enabled',
      'collector_thank_you_enabled',
      'customize_disqualification_page_enabled',
      'create_grayscale_footer',
      'create_custom_html_email_message_enabled',
      'create_piping_enabled',
      'carry_forward',
      'create_custom_variables_enabled',
      'create_toggle_footer_enabled',
      'collector_completion_url_enabled',
      'collector_white_label_enabled',
      'custom_subdomain',
    ],
  },
  {
    category: COPY.ANALYSIS_REPORTING,
    features: [
      'real_time_results',
      'share_surveys',
      'plans_benchmarks',
      'benchmarks',
      'analyze_trends_enabled',
      'grow_2792_database_response_view',
      'analyze_combine_filters',
      'create_print_enabled',
      'download_as_ppt',
      'analyze_export_enabled',
      'analyze_can_customize_charts',
      'analyze_ta_enabled',
      'analyze_can_ta_tag',
      'grow_2792_dashboard',
      'grow_2792_dashboard_pwd_protection',
      'analyze_export_spss_enabled',
      'show_sig_diffs_enabled',
      'response_quality_enabled',
      'grow_2792_word_cloud_combine_hide',
      'analyze_sentiment_enabled',
      'show_create_crosstab',
    ],
  },
  {
    category: COPY.RESPONSE_MANAGEMENT,
    features: [
      'require_answer',
      'validate_answer',
      'randomize_answer_choices',
      'set_survey_end_date',
      'view_respondent_ip_address',
      'record_respondent_email_address',
      'set_max_response_count',
      'respondent_receipt',
    ],
  },
  {
    category: COPY.ENHANCED_SECURITY,
    features: ['password_protection', 'enable_ip_blocking'],
  },
  {
    category: COPY.PARTNER_INTEGRATIONS,
    features: [
      'send_surveys',
      'collector_mobile_sdk_enabled',
      'mobile_sdk_pull_response_data_enabled',
      'extract_data',
      'private_apps',
    ],
  },
  {
    category: EXPERIMENT_CATEGORY_COPY.grow_2792_enterprise_grade_security,
    features: [
      'admin_dashboard',
      'team_activity',
      'account_control',
      'single_sign_on',
      'global_settings',
      'custom_terms_of_use',
      'enterprise_only_integrations',
      'hipaa_enabled',
    ],
  },
];
